import { ConfirmDeleteModal } from "@/components/ConfirmDeleteModal";

interface ChatDeleteModalProps {
  isOpen: boolean;
  chatTitle?: string;
  onClose: () => void;
  onConfirm: () => void;
}

// Chat-specific wrapper around the shared confirm-delete modal. Closes
// itself after confirm (chat deletion has no in-modal loading state).
export function ChatDeleteModal({
  isOpen,
  chatTitle,
  onClose,
  onConfirm,
}: ChatDeleteModalProps) {
  return (
    <ConfirmDeleteModal
      isOpen={isOpen}
      title="Delete chat"
      message={
        <>
          Are you sure you want to delete
          {chatTitle ? (
            <>
              {" "}
              <strong>“{chatTitle}”</strong>?
            </>
          ) : (
            " this chat?"
          )}{" "}
          This cannot be undone.
        </>
      }
      onConfirm={() => {
        onConfirm();
        onClose();
      }}
      onCancel={onClose}
    />
  );
}

export default ChatDeleteModal;
